import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import login from '../views/login/login.vue'
import UserView from '../views/UserView.vue'
import NewsView from '../views/NewsView.vue'
import MainView from '../views/MainView.vue'
import BookView from '../views/BookView.vue'
import Ebook from '../views/Epub.vue'

Vue.use(VueRouter)

const originaPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originaPush.call(this, location).catch(err => err)
}


const routes = [{
        path: '/',
        name: 'home',
        component: HomeView,
    },
    {
        path: '/main',
        name: 'main',
        component: MainView,
    },
    {
        path: '/user',
        name: 'user',
        component: UserView,
        meta: { requiresAuth: true },
    },
    {
        path: '/login',
        name: 'login',
        component: login
    },
    {
        path: '/news',
        name: 'news',
        component: NewsView,
    },
    {
        path: '/ebook/:id',
        name: 'Ebook',
        component: Ebook
    },
    {
        path: '/about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/AboutView.vue')
    },
    {
        path: '/book/:id',
        name: 'book',
        component: BookView,
        meta: { requiresAuth: true },
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    if (to.path === '/') {
        next()
    } else if (to.path === '/login') {
        console.log('1')
            // 如果目标路由是登录页面
        const token = localStorage.getItem('Authorization');
        if (token) {
            console.log('2')
                // 如果已经登录，直接导航到首页
            next();
        } else {
            console.log('3')
                // 如果未登录，继续导航到登录页面
            next();
        }
    } else if (to.meta.requiresAuth) {
        const token = localStorage.getItem('Authorization');
        if (token) {
            // 如果存在有效的令牌，继续导航到首页
            next();
        } else {
            // 如果不存在有效的令牌，重定向到登录页面
            next('/login');
        }
    } else {
        // 对于其他路由，直接导航
        next()
    }
});

export default router